import { useContext } from 'react';

import { TechSupportModeContext } from '@app/providers/TechSupportMode/TechSupportModeContext';

export const useTechSupportMode = () => {
  const ctx = useContext(TechSupportModeContext);
  if (!ctx) {
    throw new Error(
      'useTechSupportMode must be used within TechSupportModeProvider'
    );
  }
  return ctx;
};
